<h1 class="mt-5 mb-3">
  {{ getPortalTitle() | async }}
</h1>
